/**
 * Wait for a global variable to be available with an optional nested property
 * @param {string} globalName - The global variable name (e.g., 'grecaptcha')
 * @param {string|null} propertyName - Optional nested property to wait for (e.g., 'render', 'execute')
 * @param {number} timeout - Timeout in milliseconds (default: 30000)
 * @returns {Promise<void>}
 */
export function waitForGlobal(globalName, propertyName = null, timeout = 30000) {
  return new Promise((resolve, reject) => {
    const startedAt = Date.now()

    const check = () => {
      if (typeof window[globalName] === 'undefined') {
        return false
      }

      if (propertyName && !(propertyName in window[globalName])) {
        return false
      }

      return true
    }

    if (check()) {
      resolve()
      return
    }

    const timer = setInterval(() => {
      if (check()) {
        clearInterval(timer)
        resolve()
        return
      }

      if (Date.now() - startedAt >= timeout) {
        clearInterval(timer)
        reject(new Error(`Timeout waiting for ${globalName}${propertyName ? `.${propertyName}` : ''}`))
      }
    }, 250)
  })
}
